import { createSelector } from "@reduxjs/toolkit"

import type { RootState } from "../../../store.ts"
import { projectWritePermissions } from "./project-edit-visibility.ts"

/**
 * The project permissions each section of the project page should read.
 *
 * Memoised because an archived project produces a fresh permission tree, and
 * `connect` compares mapped props by identity — recomputing per dispatch would
 * re-render every section on every action.
 */
export const selectProjectWritePermissions = createSelector(
  [
    (state: RootState) => state.auth?.permissions?.codes?.projects,
    (state: RootState) => state.project?.project
  ],
  projectWritePermissions
)
